import clsx from 'clsx';
import type { ComponentPropsWithRef } from 'react';
import { forwardRef } from 'react';

type ButtonColor =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info';

type ButtonProps = ComponentPropsWithRef<'button'> & { color?: ButtonColor };

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { children, color = 'primary', ...buttonProps } = props;

    return (
      <button
        ref={ref}
        type="button"
        onClick={buttonProps.onClick}
        {...buttonProps}
        className={clsx(
          'btn',
          `btn-${color}`,
          buttonProps.disabled && 'disabled',
          buttonProps.className
        )}
      >
        {children}
      </button>
    );
  }
);
Button.displayName = '@signate-cloud/Button';
